import { faChevronLeft, faChevronRight, faSearchPlus } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { ReactImageGalleryItem } from "react-image-gallery";

import { Props } from "@/mk2/apps/strollers/containers/StrollerReviewPhoto/StrollerReviewPhotoPage";
import { strollersReviewPhotoUrl } from "@/mk2/apps/strollers/urls";
import { ImageGalleryLoadable } from "@/mk2/components/ImageGalleryLoadable";
import { LoadingSwitch } from "@/mk2/containers/LoadingSwitch/LoadingSwitch";
import { url } from "@/mk2/helpers/urls";
import { StrollerUserReviewPhotoEntity } from "@/mk2/schemas";
import { photoUrl } from "@/mk/photo/photoUrl";

import styles from "./StrollerReviewPhoto.mscss";
import "./StrollerReviewPhoto.scss";

export class StrollerReviewPhoto extends React.Component<Props> {
    public render() {
        const { loadingState, stroller } = this.props;

        return (
            <div className={styles.StrollerReviewPhoto}>
                <LoadingSwitch
                    loadingState={loadingState}
                    onLoad={this.load}
                    onRenderSuccess={this.renderSuccess}
                    hasData={!!stroller}
                />
            </div>
        );
    }

    private renderSuccess = () => {
        const { strollerReview, strollerReviewPhotos, strollerReviewPhoto } = this.props;

        const currentIndex: number = strollerReviewPhotos.findIndex(
            (p) => p.id === strollerReviewPhoto?.id,
        );

        const galleryPhotos: ReactImageGalleryItem[] = strollerReview.photos.map((p) => ({
            original: photoUrl(p.photoFile, "s720x720"),
            thumbnail: photoUrl(p.photoFile, "s150x150"),
        }));

        return (
            <>
                <div className={styles.StrollerReviewPhoto__gallery}>
                    <ImageGalleryLoadable
                        items={galleryPhotos}
                        showIndex
                        showThumbnails={false}
                        autoPlay={false}
                        showPlayButton={false}
                        showFullscreenButton={false}
                        slideDuration={500}
                        startIndex={currentIndex}
                        onSlide={this.onSlide}
                        renderLeftNav={this.renderLeftNav}
                        renderRightNav={this.renderRightNav}
                        renderCustomControls={this.renderCustomControls}
                    />
                </div>
            </>
        );
    };

    private renderLeftNav = (onClick, disabled) => {
        return (
            <div
                key="prev"
                className={styles.StrollerReviewPhoto__prev}
                onClick={disabled ? undefined : onClick}
            >
                <FontAwesomeIcon
                    icon={faChevronLeft}
                    className={styles.StrollerReviewPhoto__prev__icon}
                />
            </div>
        );
    };

    private renderRightNav = (onClick, disabled) => {
        return (
            <div
                key="next"
                className={styles.StrollerReviewPhoto__next}
                onClick={disabled ? undefined : onClick}
            >
                <FontAwesomeIcon
                    icon={faChevronRight}
                    className={styles.StrollerReviewPhoto__next__icon}
                />
            </div>
        );
    };

    private renderCustomControls = () => {
        const { strollerReview, photoId } = this.props;
        const photo: StrollerUserReviewPhotoEntity = strollerReview.photos.find(
            (p) => p.photoFile.id === photoId,
        );
        const showMagnifier = photo?.photoFile?.versions?.includes("s1600x1600");
        if (!showMagnifier) {
            return null;
        }

        return (
            <div className={styles.StrollerReviewPhoto__controls}>
                {showMagnifier && (
                    <a
                        data-google-interstitial="false"
                        key="magnifier"
                        href={photoUrl(photo.photoFile, "s1600x1600")}
                        target="_blank"
                        rel="noopener"
                        className={styles.StrollerReviewPhoto__controls__control}
                    >
                        <FontAwesomeIcon icon={faSearchPlus} />
                    </a>
                )}
            </div>
        );
    };

    private onSlide = (currentIndex: number) => {
        const {
            strollerReview,
            routeNavigate,
            routeParams: { slug, reviewId },
        } = this.props;

        const photo = strollerReview.photos[currentIndex];
        routeNavigate(
            url(strollersReviewPhotoUrl, {
                slug,
                reviewId,
                photoId: photo.photoFile.id,
            }),
            { replace: true },
        );
    };

    private load = () => {
        const { strollerSlug, reviewId, photoId, onLoad } = this.props;
        onLoad(strollerSlug, reviewId, photoId);
    };
}
